/* eslint-disable new-cap */
/* eslint-disable prettier-vue/prettier */
import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import VueMeta from 'vue-meta'
import Bowser from 'bowser'
import smoothscroll from 'smoothscroll-polyfill';
import Helpers from './utils/helpers.js'
import reveal from './directives/reveal.js'

import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'

import './assets/sass/app.scss'

// kick off the polyfill!
smoothscroll.polyfill();
Vue.use(Helpers)
Vue.directive('reveal', reveal)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
Vue.config.productionTip = false

window.appVue = new Vue({
  data() {
    return {
      windowTop: 0,
      width: null,
      height: null,
      desctopMinBreakpoint: 1500,
      tabletBreakpoint: 1200,
      tabletSmallBreakpoint: 1024,
      mobileBreakpoint: 768,
      bowser: null,
    }
  },
  computed: {
    isDesctopMin() {
      return this.width <= this.desctopMinBreakpoint
    },
    isTablet() {
      return this.width <= this.tabletBreakpoint
    },
    isSmallTablet() {
      return this.width <= this.tabletSmallBreakpoint
    },
    isMobile() {
      return this.width <= this.mobileBreakpoint
    },
  },
  watch: {},
  async created() {
    this.width = window.innerWidth
    this.height = window.innerHeight
    this.bowser = Bowser.parse(window.navigator.userAgent)
  },
  mounted() {
    this.addListeners()
  },
  methods: {
    addListeners() {
      window.addEventListener('scroll', this.onScroll, { passive: true })
      window.addEventListener('resize', this.onResize)
    },
    onScroll(e) {
      this.windowTop = window.pageYOffset
    },
    onResize(state) {
      this.width = window.innerWidth
      this.height = window.innerHeight
      document.body.classList.remove('scroll-off')
    },
    async goTo(link) {
      if (!this.scrollToSection(link)) {
        try {
          await this.$router.push({
            path: '/'
          })
        } catch (error) {}
        setTimeout(() => {
          this.scrollToSection(link)
        }, 500)
      }
    },
    scrollToSection(link) {
      const target = document.querySelector(link)
      if (!target) {
        return false
      }
      // Land the section content just below the fixed header
      const header = document.querySelector('.header')
      const padding = parseFloat(getComputedStyle(target).paddingTop) || 0
      const offset = link === '#top' ? 0 : padding - (header ? header.offsetHeight : 0) - 32
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.pageYOffset + offset,
        behavior: 'smooth'
      })
      return true
    }
  },
  router,
  render: h => h(App)
}).$mount('#app')
